import React, { useMemo, useState } from "react";
import "../styles/AboutPage.css";
import "../styles/InspirePage.css";
import { useNavigate } from "react-router-dom";

const FEATURED_COLLECTION =
  "https://thecollectorsplatform.com/#/view-collection?c=My%20travel%20magnets&u=bea&mode=public";

const CREATE_VIDEO =
  "https://player.vimeo.com/video/1126629542?title=0&byline=0&portrait=0";

function parseMeta(url) {
  try {
    const qs = url.split("?")[1] || "";
    const params = new URLSearchParams(qs);
    const c = decodeURIComponent(params.get("c") || "");
    const u = decodeURIComponent(params.get("u") || "");
    return { title: c, owner: u };
  } catch {
    return { title: "", owner: "" };
  }
}

const InspirePage = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(null); // 'create' | 'edit' | 'share' | null
  const meta = useMemo(() => parseMeta(FEATURED_COLLECTION), []);

  return (
    <main className="about-page" role="main">
      <p className="tagline"></p>

      <section className="inspire-grid">
        {/* LEFT — Featured card (first page only) */}
        <div className="inspire-left">
          <div className="panel active panel-elevated">
            <h3 className="panel-title">featured collection</h3>

            {/* Cropped, non-interactive preview */}
            <div className="preview-card">
              <iframe
                title="featured collection (preview)"
                src={FEATURED_COLLECTION}
                className="preview-iframe"
              />
            </div>

            {/* Metadata row */}
            <div className="meta-row">
              <div className="meta-text">
                <div className="meta-title">{meta.title || "collection"}</div>
                <div className="meta-sub">by {meta.owner || "collector"}</div>
              </div>
              <button
                className="community-cta open-full"
                onClick={() =>
                  window.open(FEATURED_COLLECTION, "_blank", "noopener,noreferrer")
                }
              >
                open the full collection →
              </button>
            </div>
          </div>
        </div>

        {/* RIGHT — Actions + inline instructions */}
        <div className="inspire-right">
          <div className="panel active panel-elevated">
            <h3 className="panel-title">key features</h3>

            <div className="action-buttons">
              <button
                className={`community-cta ${open === "create" ? "active" : ""}`}
                onClick={() => setOpen(open === "create" ? null : "create")}
                aria-expanded={open === "create"}
              >
                💿 create your collection
              </button>

              <button
                className={`community-cta ${open === "edit" ? "active" : ""}`}
                onClick={() => setOpen(open === "edit" ? null : "edit")}
                aria-expanded={open === "edit"}
              >
                ✏️ edit your collection
              </button>

              <button
                className={`community-cta ${open === "share" ? "active" : ""}`}
                onClick={() => setOpen(open === "share" ? null : "share")}
                aria-expanded={open === "share"}
              >
                🎁 share your collection
              </button>
            </div>

            {/* --- CREATE --- */}
            {open === "create" && (
              <div className="instruction">
                <p className="panel-sub">
                  watch the demo and create your own
                </p>
                <div className="ratio-16x9">
                  <iframe
                    title="Create a new collection"
                    src={CREATE_VIDEO}
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                  />
                </div>
                <div className="inline-ctas">
                  <button
                    className="community-cta"
                    onClick={() => navigate("/upload-collection")}
                  >
                    start a new collection →
                  </button>
                </div>
              </div>
            )}

            {/* --- EDIT --- */}
            {open === "edit" && (
              <div className="instruction">
                <p className="panel-sub">
                watch the demo (coming soon) edit or update any of your collections
                </p>
                <div className="inline-ctas">
                  <button
                    className="community-cta"
                    onClick={() => navigate("/edit-collection-selector")}
                  >
                    edit my collection →
                  </button>
                </div>
              </div>
            )}

            {/* --- SHARE --- */}
            {open === "share" && (
              <div className="instruction">
                <p className="panel-sub">
                  watch the demo (coming soon) and share a private or public view
                  of your collection
                </p>
                <div className="inline-ctas">
                  <button
                    className="community-cta"
                    onClick={() => navigate("/view-collection-selector")}
                  >
                    view my collection →
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      <button
        type="button"
        className="community-back-button"
        onClick={() => (window.location.href = "/#/home-page")}
      >
        ← back to home
      </button>
    </main>
  );
};

export default InspirePage;
